<template>
  <ClicColInterno 
    md="12" 
    :cp="cp" 
    :key="componentKey" 
    containerStyle="height: 100%;width: 100%;"
  >
    <template>
      <MotorS 
        ref="rowFiltros" 
        :cp="cp" 
        :childrens="filterElements" 
        :idTela="idTela" 
      />
    </template> 
    <b-row 
      style="height: 100%;"
      class="p-1"
    >
      <b-col v-for="chart in chartElements" 
        :key="chart.chartId" 
        :sm="chart.sm || ''"
        :md="chart.md || ''" 
        :lg="chart.lg || ''" 
        :xl="chart.xl || ''" 
        class="p-1" 
        style="height: 70%; position: relative;"
      >
        <div 
          :id="chart.chartId"
          style="height: 100%; width: 100%;"    
          @click="openChartModal(chart)"
        ></div>
        <div 
          class="chart-overlay" 
        >
        <b-dropdown variant="link" no-caret dropleft toggle-class="p-0">
          <template #button-content>
            <ClicIconInterno iconName="md-morehoriz-round" iconTitle="Opções" />
          </template>

          <b-dropdown-item @click="openExportModal(chart)">
            Ver/Exportar Relatório
          </b-dropdown-item>
        </b-dropdown>

        <b-button variant="link" class="p-0 ml-1" @click="openChartModal(chart)">
          <ClicIconInterno iconName="md-fullscreen-round" iconTitle="Expandir Gráfico" />
        </b-button>
      </div>
      </b-col>
    </b-row>
    <b-modal
      v-model="showModal"
      size="xl"
      hide-footer
      hide-header
    >
      <div 
        :id="modalChartId" 
        style="height: 70vh; width: 100%;"
      ></div>
    </b-modal>

    <b-modal
      v-model="showExportModal"
      size="lg"
      hide-header
      centered  
    >
      
      <MotorS 
        ref="rowExportedDataTable" 
        :cp="cp" 
        :childrens="tableData" 
        :idTela="idTela" 
      />

      <template #modal-footer>
        <b-button variant="outline-secondary" class="border-0" @click="exportChartData('json')">
          Exportar JSON
        </b-button>
        <b-button variant="outline-secondary" class="border-0" @click="exportChartData('csv')">
          Exportar CSV
        </b-button>
        <b-button variant="primary" @click="showExportModal = false">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </ClicColInterno>
</template>

<script>

import ComponentMixin from '../../core/ComponentMixin';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import storage from '../../store/modules/storage';
import lodash from 'lodash';
import { BRow, BCol, BDropdown, BDropdownItem, BButton, BModal } from 'bootstrap-vue';

export default {
  name: 'ClicMongoDBChart',
  mixins: [ComponentMixin],
  components: { BRow, BCol, BDropdown, BDropdownItem, BButton, BModal },
  data() {
    return {
      public: {
        dataRefresh   : this.generateCharts,
        applyFilters  : this.applyFilters,
        clearFilters  : this.clearFilters
      },
      filter          : [],
      filterElements  : [],
      charts          : [],
      chartElements   : [],
      tableData       : [],
      filtrosPadrao   : {},
      exportedData    : {},
      showExportModal : false,      
      showModal       : false,      
      modalChartId    : null,        
      modalChart      : null        
    };
  },

  mounted() {
    this.getClicDashboard();
  },
  methods: {

    /**
     * Obtém o dashboard via API e extrai gráficos e filtros 
    */
    async getClicDashboard() {
      if (this.clicDashboardId) {
        const options = {
          method  : 'GET',
          url     :`https://${this.$host.subdominio}.clictecnologia.com.br/api/mongodashboard`,
          headers : { "content-type": "application/json" },
          params  :  { subdominio: this.$host.subdominio, id: this.clicDashboardId }
        };

        try {
          const response  = await this.$axios.request(options);
          const dashboard = response.data.dados?.dashboards;

          this.filters = dashboard?.filtros.sort((a, b) => a.configuracoes?.ordem - b.configuracoes?.ordem);
          await this.renderFilters();

          this.charts  = dashboard?.charts.sort((a, b) => a.position - b.position);
          this.generateCharts(this.filtrosIniciais);

        } catch (e) {
          console.error("[ClicMongoDBChart] Erro ao buscar o dashboard:", e);
        }
      }
    },

    /**
     * Percorre os gráficos obtidos e resolve os filtros correspondentes para cada um deles,
     * preparando os dados filtrados que serão utilizados na renderização de cada gráfico.
     */
    async generateCharts(filtroOpcional) {
      if (this.charts) {
        this.chartElements       = [];
        const filtros            = this.getFilters(filtroOpcional);

        this.charts.map(chart => {
          const filtrosPermitidos = this.extractAllowedFilters(chart, filtros)
          this.createChartElement({ ...chart }, filtrosPermitidos)
        });
      }

    },

    /**
     * Cria e insere um elemento gráfico na interface com base na configuração recebida,
     * inicializando o SDK do MongoDB Charts e aplicando os filtros correspondentes.
     */
    createChartElement(chart, filtros) {
      if (!this.baseUrl || !chart.chartId) { 
        console.error("[ClicMongoDBChart] Parâmetros baseUrl ou chartId são obrigatórios.") 
      };

      if (chart.visible) {
        this.chartElements.push({ ...chart });

        this.$nextTick(() => {
          const sdk = new ChartsEmbedSDK({ baseUrl: this.baseUrl, ...chart });
          this.loadChart({sdk, chartId: chart.chartId, filtros})
        });
      } 
    },

    /**
     * Renderiza o gráfico aplicando os filtros
     */
    loadChart(parametros) {
        let { sdk, chartId, chartElement, filtros } = parametros;

        const chart = sdk.createChart({
          getUserToken: () => storage.getToken(),
          showAttribution: false,
          filter: filtros || {},
        });

        if(!chartElement){ chartElement = document.getElementById(chartId) }

        if (chartElement) {
          chart.render(chartElement)
            .then(()   => { chartElement.sdkInstance = chart})
            .catch((e) => { console.error(`[ClicMongoDBChart] Falha ao carregar 'chart'. Detalhes: ${e}`)});
        }
    },

    /**
     * Abre o modal com o gráfico ampliado
     */
    openChartModal(chart) {
      this.showModal    = true;
      this.modalChart   = chart;
      this.modalChartId = `modal-chart-${chart.chartId}`;
      this.$nextTick(() => { this.renderModalChart(chart) });
    },

    /**
     * Renderiza o gráfico que aparecerá no modal,
     * obtém os filtros permitidos
     */
    renderModalChart(selectedChart) {
      if (!selectedChart || !this.baseUrl) return;

      const sdk = new ChartsEmbedSDK({
        chartId: this.modalChartId,
        baseUrl: this.baseUrl,
        ...selectedChart
      });

      const modalChartElement = document.getElementById(this.modalChartId);
      const filtros           = this.getFilters();
      const filtrosPermitidos = this.extractAllowedFilters(this.modalChart, filtros)

      this.loadChart({sdk, chartId: this.modalChartId, chartElement: modalChartElement , filtros: filtrosPermitidos});
    },

    /**
     * Função chamada através do botão de filtrar, percorre os gráficos instanciados e aplica os filtros permitidos
     */
    applyFilters(filtroAdicional = {}) {
      const filtros = this.getFilters(filtroAdicional);
 
      this.chartElements.forEach(chart => {
        const chartElement      = document.getElementById(chart.chartId);
        const filtrosPermitidos = this.extractAllowedFilters(chart, filtros)
        if (chartElement) {
          chartElement.sdkInstance.setFilter(filtrosPermitidos)
            .catch((e) => { console.error(`[ClicMongoDBChart] Erro ao aplicar filtros: ${e}`) });
        }
      });  
    },

    /**
     * Limpa os filtros do cabeçalho
     */
    clearFilters() {
      const comp = this.$getComponents();
      comp.rowFiltros.clearForm();
      this.updateBadgeFilters({});
    },

    /**
     * Obtém os fitros permitidos para cada gráfico
     */
    extractAllowedFilters(chart, filtros){
      let filtrosDashboard   = { ...filtros };
      let { allowedFilters } = chart;
      
      if (allowedFilters && Array.isArray(allowedFilters)) {
        return Object.fromEntries(
          Object.entries(filtrosDashboard).filter(([campo]) =>
            allowedFilters.some(prefixoPermitido =>
              campo === prefixoPermitido || campo.startsWith(`${prefixoPermitido}.`)
            )
          ) 
        );
      }
      return filtrosDashboard;
    },

    /**
     * Percorre os componentes do cabeçalho, monta os filtros fazendo as substituições do regex caso possua
     * e mescla com filtros adicionais e filtros padrão. Também atribui os valores de filtro adicional em seus respectivos campos
     * assim os filtros enviados sempre estarão "sincronizados" com o que é exibido no collapse
     */
    getFilters(filtroAdicional) {
      const pathFiltros        = "rowFiltros.childrens[0].childrens[0].childrens[0].childrens"
      const componentesFiltros = lodash.get(this.$refs, pathFiltros, []);
      const comp               = this.$getComponents();
      let filtros              = {};

      for (const componente of componentesFiltros) {
        const jsonId  = componente.props.jsonId;
        let value     = comp[componente.id].getPropValue("value");
        if (jsonId && value && value != '') {
          if (componente.filtroMongo?.regex) {
            const valorSubstituido  = lodash.get(value, componente.filtroMongo.propriedade, value);
            let regex               = componente.filtroMongo.regex;
            value                   = JSON.parse(regex.replace("@VALUE@", valorSubstituido));
          }

          if (!filtros[jsonId]) {
            filtros[jsonId] = value
          } else {
            filtros[jsonId] = lodash.merge({}, filtros[jsonId], value);
          }


        }else if(filtroAdicional && jsonId){
          const valueForComp = this.findAdditionalValueForComponent({filtroAdicional, jsonId, componente});
          if(valueForComp){ comp[componente.id].setPropValue("value", valueForComp) }
        }
      }

      const filtrosPadraoValidos = lodash.pickBy(this.filtrosPadrao, valido => !lodash.isEmpty(valido));
      filtros = lodash.merge({}, filtrosPadraoValidos, filtros, filtroAdicional);
      this.updateBadgeFilters(filtros);
      return filtros;
    },

    /**
     * Recupera o valor do filtro adicional e extrai o valor adequado 
     * para ser aplicado no componente de filtro, realizando as transformações 
     * necessárias (como substituição por regex ou mapeamento de propriedade).
     */
    findAdditionalValueForComponent(parameters){
      let { filtroAdicional, jsonId, componente } = parameters;
      let newValueForComp = filtroAdicional[jsonId]; 

      if (newValueForComp !== undefined) {
        if(componente.filtroMongo.regex){
          newValueForComp = this.extractCorrectValueFromRegex(componente.filtroMongo.regex, newValueForComp);

          if(componente.filtroMongo.propriedade){
            const baseObject = {
              descricao   : newValueForComp,
              label       : newValueForComp,
              nome        : newValueForComp,
              fantasia    : newValueForComp,
              razaoSocial : newValueForComp,
              situacao    : newValueForComp,
            }
            newValueForComp =  lodash.merge(baseObject, { [componente.filtroMongo.propriedade] : newValueForComp });
          }
        }
        return newValueForComp;
      }
      return undefined;
    }, 

    /**
     * Encontra o caminho até o valor "@VALUE@" no objeto.
     */
    findVALUEIntoObject(obj, path = []) {
      for (const key in obj) {
        const value = obj[key];
        if (value === "@VALUE@") {
          return [...path, key];
        } else if (typeof value === "object" && value !== null) {
          const subCaminho = this.findVALUEIntoObject(value, [...path, key]);
          if (subCaminho) return subCaminho;
        }
      }
      return null;
    },

    /**
     * Extrai o valor de valorAdicional com base no caminho do regex.
     */
    extractCorrectValueFromRegex(regexStr, filtro) {
      try {
        const regexObj = JSON.parse(regexStr);
        const path = this.findVALUEIntoObject(regexObj);
        if (path) {
          return lodash.get(filtro, path);
        }
      } catch (e) {}
      return filtro; 
    },

    updateBadgeFilters(obj){
      this.$nextTick(() => {
        const comp = this.$getComponents();
        this.lodash.invoke(comp, "collapseFiltros.setPropValue", "badgeText",  `Filtros aplicados: ${Object.keys(obj).length}`);
        this.lodash.invoke(comp, "collapseFiltros.setPropValue", "badgeVariant", "primary");
      })
    },

    /**
     * Renderiza os componentes de filtro no collapse 
     */
    async renderFilters() {
      if (this.filters) {
        let childrenFiltro = []
        
        this.filters.forEach((filtro) => {
          childrenFiltro.push({ ...filtro.componente, filtroMongo: filtro.filtroMongo });
        });

        if(childrenFiltro.length > 0){
          this.filterElements = [{
            "id"        : "containerFiltros",
            "component" : "ClicRow",
            "props"     : { "visible": true },
            "events"    : {},
            "childrens" : [
              {
                "id"        : "collapseFiltros",
                "component" : "ClicCollapse",
                "props"     : { "visible": true, "label": "Filtros" },
                "events"    : {},
                "childrens" : [
                  {
                    "id"        : "rowFiltros",
                    "component" : "ClicRow",
                    "props"     : { "visible": true },
                    "events"    : {},
                    "childrens" : [
                      ...childrenFiltro,
                      {
                        "id"        : "inputGroup",
                        "component" : "ClicInputGroup",
                        "props"     : { "visible": true, "label": "Filtros", "style":"justify-content: end" },
                        "events"    : {},
                        "childrens" : [
                          {
                            "id"        : "buttonInternoLimpar",
                            "component" : "ClicButton",
                            "props"     : { "slot": "append", "visible": true, "label": "Limpar", "variant": "outline-danger" },
                            "events"    : {
                              "click": `let comp = this.$getComponents(); comp['${this.cp.id}'].clearFilters()`
                            },
                          },
                          {
                            "id"        : "buttonInternoFiltrar",
                            "component" : "ClicButton",
                            "props"     : { "slot": "append", "visible": true, "label": "Filtrar", "variant": "primary" },
                            "events"    : {
                              "click": `let comp = this.$getComponents(); comp['${this.cp.id}'].applyFilters(); comp.collapseFiltros.toggleContainer()`
                            },
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }];
        }

        await this.$nextTick();

      }
    },

    /**
     * Obtém os dados do gráfico que será exportado, chama a função para renderizar a tabela e
     * abre o modal de exportação 
     */    
    openExportModal(chart) {      
      if(!chart){
        this.$notificacao({ text: `Ocorreu um erro ao obter os dados. Tente novamente mais tarde`, type: 'warning' });
        return;
      }

      const chartElement = document.getElementById(chart.chartId);
      const sdkInstance  = chartElement?.sdkInstance;

      if (!sdkInstance) {
        this.$notificacao({ text: `O gráfico ainda está sendo carregado. Por favor, aguarde alguns instantes e tente novamente.`, type: 'warning'});
        return;
      }

      sdkInstance.getData()
        .then(data => {
          this.exportedData  = {...data, chartId: chart.chartId};
          this.renderExportedDataTable();

          if(this.exportedData.documents.length > 0){
            this.showExportModal = true;
          }else{
            this.$notificacao({ text: `Este gráfico não possui dados para exportação no momento. Considere revisar os filtros aplicados.`, type: 'warning' });
          } 
        })
        .catch(e => {
          this.$notificacao({ text: `Erro ao obter dados do gráfico. Tente novamente mais tarde`, type: 'warning' });
        });
    },

    /**
     * Gerencia o tipo de arquivo que será gerado com os dados para exportação 
     */
    exportChartData(format = "json") {
      try{
        if (format === "json") {
          this.downloadFile(JSON.stringify({documents: this.exportedData.documents}, null, 2), `clic-${this.exportedData.chartId}.json`, 'application/json');
        } else if (format === "csv") {
          const csv = this.convertToCSV(this.exportedData.documents);
          this.downloadFile(csv, `clic-${this.exportedData.chartId}.csv`, 'text/csv');
        } 
      }catch(error){
        this.$notificacao({ text: `Erro ao gerar o arquivo. Tente novamente mais tarde`, type: 'warning' });
      }
        
    },

    /**
     * Renomeia as propriedades dos documentos que serão exportados 
     */
    renameKeyValues(){
      this.exportedData.documents = this.exportedData.documents.map(documento => {
        const novoDocumento = {};

        Object.entries(this.exportedData.fields).forEach(([chaveOriginal, labelLegivel]) => {
          const chaveCamelCase = this.toCamelCase(labelLegivel);
          novoDocumento[chaveCamelCase] = documento[chaveOriginal];
        });

        return novoDocumento;
      });
    },

    /**
     * Cria dinamicamente as colunas da tabela com os dados que serão exportados com
     * base no conteúdo do gráfico selecionado 
     */
    createTableColumns(){
      let columnsExportedData = []
      Object.entries(this.exportedData.fields).forEach(([chave, valor]) => {
        columnsExportedData.push({
          id       : "column" + chave,
          component: "ClicTableColumnText",
          props: {
            visible: true,
            label  : valor,
            key    : this.toCamelCase(valor),
            sortKey: this.toCamelCase(valor)
          },
          events   : {},
          childrens: []
        });
      }); 
      return columnsExportedData;
    },

    /**
     * Monta e renderiza a tabela que com os dados que serão exportados
     */
    renderExportedDataTable() {
      try{
        if (this.exportedData?.documents?.length) {
          this.renameKeyValues()
          const columnsExportedData   = this.createTableColumns();
          
          if(columnsExportedData.length > 0){
            this.tableData = [
              {
                "id"       : "tableExportedItems",
                "component": "ClicTable",
                "props": {
                  "visible"         : true,
                  "controlsTopMenu" : false,
                  "sortDesc"        : true,
                  "itemsPerPage"    : 10,
                  "stacked"         : "lg",
                  "striped"         : true,
                  "dataRow"         : this.exportedData.documents,
                  "small"           : true,
                  "keysFilter"      : [],
                  "noSelectOnClick" : true,
                  "selectable"      : false
                },
                "events": {},
                "childrens": [
                  {
                    "id"       : "tableHeaderExportedItems",
                    "component": "ClicTableHeader",
                    "props": {
                      "visible": true
                    },
                    "events"   : {},
                    "childrens": columnsExportedData
                  }
                ]
              }
            ];
          }else{
            this.tableData = []
          }
          
        }
      }catch(error){
        console.error(`ClicMongoDBChart - Erro ao criar colunas:  ${error.toString()}`)
        this.$notificacao({ text: `Erro ao criar colunas da tabela. Tente novamente mais tarde`, type: 'warning' });
      }
    },

    /**
     * Cria e faz o download do arquivo no navegador
     */
    downloadFile(content, fileName, mimeType) {
      const blob = new Blob([content], { type: mimeType });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
    },

    /**
     * Converte JSON para CSV 
     */
    convertToCSV(data) {
      if (!data.length) return '';
      const keys = Object.keys(data[0]);
      const csvRows = [keys.join(',')];

      data.forEach(row => {
        const values = keys.map(k => JSON.stringify(row[k] ?? ''));
        csvRows.push(values.join(','));
      });

      return csvRows.join('\n');
    },

    /**
     * Transforma a string em camelCase
     */
    toCamelCase(str) {
      return str
        .replace(/[^a-zA-Z0-9 ]/g, '')  
        .split(' ')
        .map((word, index) =>
          index === 0 
            ? word.toLowerCase() 
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join('');
    },

  },
};
</script>


<style>
.Charts_app-dashboard-shared_layout---mtgxT {
  padding: 0px !important;
}


.chart-overlay {
  display: flex;
  position: absolute;
  top: 10px;
  right: 25px;
  width: 5%;
  height: 5%;
  background: rgba(0, 0, 0, 0);
  cursor: pointer;
  z-index: 10;
  align-items: center;
  justify-content: center;
}


</style>